module.exports = __webpack_public_path__ + "assets/img/2827-pa.svg";